import {
  Anchor,
  Button,
  Card,
  Center,
  Divider,
  Stack,
  ThemeIcon,
  Title,
  TypographyStylesProvider,
  Image,
  Code,
} from "@mantine/core";

import React from "react";
import DocsHighlightCard from "../articlesHelpers/DocsHighlightCard";
import {
  IconArrowBigDownFilled,
  IconAt,
  IconExchange,
  IconRocket,
} from "@tabler/icons-react";
import DocsButton from "../articlesHelpers/DocsButton";
import SimpleImage from "../articlesHelpers/SimpleImage";

export const RECEIVE_TO_LIGHTNING_ADDRESS_CONTENT = (
  <TypographyStylesProvider>
    <p>
      Your first option for receiving lightning payments is to copy and use a
      Lightning address.
    </p>
    <DocsButton
      ariaLabel="Receive To Lightning Address"
      text="Receive To Lightning Address"
      leftSection={<IconAt />}
    />
    <p>
      {" "}
      Clicking this will reveal a dialog where you can modify your lightning
      address, and copy it to your clipboard:
    </p>
    <SimpleImage h={400} src="docs_images/make-lightning-address.png" />
    <p>
      A Lightning Address is a way to receive payments on the network with a
      short text string that you can freely distribute to others. In the image
      above, the address is
      <Code>colorful-cicada-1@rizful.com</Code>.
    </p>
    <p>
      {" "}
      This short text string looks like an email address, but you can't receive
      email with it. Instead, you can receive payments with it.
    </p>
    <p>
      Many mainstream wallets and service providers support these addresses, so
      they are convenient. There are some details you should keep in mind,
      however.
    </p>
    <p>
      <strong>
        {" "}
        You can change your lightning address a limited number of times
      </strong>
      . This is due to technical limitations, but also, it will be confusing for
      your payees if you change your address frequently. Best practice is to
      find an address you like, and never change it.
    </p>
    <p>
      <strong>
        Your address is associated with your node, not your Rizful Node account.
      </strong>{" "}
      A Rizful Node account may start and run multiple nodes at the same time.
      Each one will have a separate and unique lightning address.
    </p>
    <p>
      <strong>Lightning addresses are not great for privacy.</strong> You should
      not include identifying details such as your name or birthday in your
      lightning address. But even still, if you provide an @rizful.com lightning
      address, everyone will know that you are running a Rizful node.
    </p>
    <p>
      <strong>Your node must be online and running in order to receive.</strong>{" "}
      If your node is stopped, your lightning address will not work!
    </p>
  </TypographyStylesProvider>
);
